export default {
  LOAD_RESULTS (state, payload) {
    state.results = payload
  },
  UPDATE_RESULT_IS_ADDED (state, payload) {
    state.results[payload.index].isAdded = payload.status
  },
  UPDATE_RESULT_MC_INFO (state, payload) {
    state.results[payload.index].mc = payload.mc
  },
  LOAD_TOTAL (state, payload) {
    state.total = payload
  },
  LOAD_TERMS (state, payload) {
    state.terms = payload
  },
  LOAD_SORT (state, payload) {
    state.sort = payload
  },
  LOAD_SOURCE (state, payload) {
    state._source = payload
  },
  LOAD_FROM (state, payload) {
    state.from = payload
  },
  LOAD_SIZE (state, payload) {
    state.size = payload
  },
  LOAD_QUERY (state, payload) {
    state.query = payload
  },
  LOAD_FILTER (state, payload) {
    state.filter = payload
  },
  LOAD_AGGS (state, payload) {
    state.aggs = payload
  },
  LOAD_AGGREGATIONS (state, payload) {
    state.aggregations = payload
  },
  LOAD_INDEXLIST (state, payload) {
    state.indexList = payload
  },
  LOAD_LIBRARYLIST (state, payload) {
    state.libraryList = payload
  },
  LOAD_PRIVATELIBRARYLIST (state, payload) {
    state.privateLibraryList = payload
  },
  LOAD_PUBLICLIBRARYLIST (state, payload) {
    state.publicLibraryList = payload
  },
  LOAD_PAGE_NUMBER (state, payload) {
    state.pageNumber = payload
  },
  LOAD_RESET_SELECTED_ITEMS (state, payload) {
    state.isResetSelectedItems = payload
  },
  LOAD_LIBRARY_POSTION_MAPPING (state, payload) {
    state.libraryPositionMapping = payload
  },
  LOAD_DEPARTMENT_MAP (state, payload) {
    state.departmentMap = payload
  },
  LOAD_DIVISION_MAP (state, payload) {
    state.divisionMap = payload
  },
  LOAD_SUBJECT_MAP (state, payload) {
    state.subjectMap = payload
  },
  LOAD_INSTRUCTOR_MAP (state, payload) {
    state.instructorMap = payload
  },
  LOAD_MAJOR_MAP (state, payload) {
    state.majorMap = payload
  },
  LOAD_UNIT_MAP (state, payload) {
    state.unitMap = payload
  },
  LOAD_START_TIME_MAP (state, payload) {
    state.startTimeMap = payload
  },
  LOAD_END_TIME_MAP (state, payload) {
    state.endTimeMap = payload
  },
  LOAD_BLOCK_MAP (state, payload) {
    state.blockMap = payload
  },
  LOAD_LEVEL_MAP (state, payload) {
    state.levelMap = payload
  },
  LOAD_COURSE_SEARCHES (state, payload) {
    state.courseSearches = payload
  },
  LOAD_COURSE_FLAGS (state, payload) {
    state.courseFlags = payload
  },
  UPDATE_LAST_UPDATED_TIME (state, payload) {
    state.lastUpdatedTime = payload
  },
  SHOW_DROP_DOWN (state, payload) {
    state.shouldShowDropDown = payload
  },
  UPDATE_PAGE_NUMBER (state, payload) {
    state.pageNumber = payload
  },
  UPDATED_SELECTED_INDEXES (state, payload) {
    state.selectedIndexes = payload
  },
  DELETE_COURSE_SEARCH (state, payload) {
    state.courseSearches.splice(state.courseSearches.indexOf(payload), 1)
  },
  LOAD_MATCH_ALL (state, payload) {
    state.matchAllInTags = payload
  },
  LOAD_MATCH_AT_LEAST_ONE (state, payload) {
    state.matchAtLeastOneInTags = payload
  },
  UPDATE_SELECTED_FACETS (state, payload) {
    state.selectedFacets[payload.key] = payload.value || []
  }
}



// WEBPACK FOOTER //
// ./src/app/search/vuex/mutations.js